import { ICellTypeHandler } from "components/grecoreactgrid/ICellTypeHandler";

import {
  CustomCheckmarkCell,
  CustomCheckmarkCellTemplate,
} from "../customcells/CustomCheckmarkCellTemplate";

class CustomCheckmarkCellTypeHandler implements ICellTypeHandler {
  cellType = "customcheckmark";
  isCustom = true;
  instance = new CustomCheckmarkCellTemplate();
  determineNewValue = (change: any) => {
    return (change.newCell as CustomCheckmarkCell).checked;
  };
  getEntryRow = (
    entry: any,
    columnConfig: any,
    rowsMetadataMap: any,
    keyColumn: string,
    context: {
      [key: string]: any;
    }
  ) => {
    let redColor = false;
    if (columnConfig.additionalInfo && columnConfig.additionalInfo?.redColorFn) {
      redColor = columnConfig.additionalInfo.redColorFn(entry);
    }
    const value = entry[columnConfig.columnId];
    return {
      type: "customcheckmark",
      tooltip: null,
      checked: value === true,
      selected: rowsMetadataMap[entry[keyColumn]]?.selected ?? false,
      highlighted: rowsMetadataMap[entry[keyColumn]]?.highlighted ?? false,
      redColor: redColor,
      // no value: leave the cell empty rather than rendering a check / cross
      blank: value === null || value === undefined,
      checkedText: "",
      editable: rowsMetadataMap[entry[keyColumn]]?.editable ?? true,
    };
  };
}

export default CustomCheckmarkCellTypeHandler;
